import { formatDistanceToNowStrict, format, parseISO } from 'date-fns';

export function relativeTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
  } catch {
    return iso;
  }
}

export function shortDateTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM, h:mm a');
  } catch {
    return iso;
  }
}

export function shortDate(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM yyyy');
  } catch {
    return iso;
  }
}
